import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { MobileHeader } from "../../../../stories/MobileHeader/MobileHeader";
import css from "./ProfileMobile.module.css";
import Colors from "../../../../stories/assets/Colors";
import MobileCoachProfileDetailCard from "../../../../stories/MobileCoachProfileDetailCard/MobileCoachProfileDetailCard";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import Fonts from "../../../../stories/assets/Fonts";
import {
  blackStarIcon,
  insightBlackIcon,
  helpIconBlack,
  profileIconBlack,
  editLessonBlack,
  settingBlack,
  logoutBlackIcon,
  bookingIconGray,
  HomeIconGray,
  messageIconGray,
  NotificationIconGray,
  ProfileIconGray,
} from "../../../../constant/imagePath";
import MobileBottomTab from "../../../../stories/MobileBottomTab/MobileBottomTab";
import { useHistory, useLocation } from "react-router";
import { useDispatch } from "react-redux";
import { setActiveTab } from "../../../../store/Actions/commonAction";

const ProfileMobile = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const [menuItem, setMenuItem] = useState(location?.pathname?.split("/")[1]);

  const demoData = [
    {
      title: "Reviews",
      icon: blackStarIcon,
      onClick: () => history.push("/reviews"),
    },
    {
      title: "Insights",
      icon: insightBlackIcon,
      onClick: () => history.push("/insights"),
    },
    {
      title: "Help",
      icon: helpIconBlack,
      onClick: () => history.push("/help"),
    },
    {
      title: "Edit Profile",
      icon: profileIconBlack,
      onClick: () => {
        history.push("/edit-profile");
        dispatch(setActiveTab("personal-info"));
      },
    },
    {
      title: "Edit Lesson Info",
      icon: editLessonBlack,
      onClick: () => {
        history.push("/edit-lesson-info");
        dispatch(setActiveTab("basic-info"));
      },
    },
    {
      title: "Setting",
      icon: settingBlack,
      onClick: () => {
        history.push("/profile-settings");
        dispatch(setActiveTab("privacy-settings"));
      },
    },
  ];


  return (
    <>
      <Container fluid className={["p-0", css.ProfileScreen].join(" ")}>
        <div>
          <MobileHeader isLogo={true} isAvatar={false} />
        </div>
        <div className={css.mainBodyContainer}>
          <MobileCoachProfileDetailCard />
          <Col md={12}>
            <p className={css.line}></p>
          </Col>
          <Row>
            <Col md={12}>
              <div className={css.dashMobileBody}>
                <ul className={["p-0"].join(" ")}>
                  {demoData.map((item, index) => {
                    return (
                      <li
                        className={index === 0 ? "" : css.marginTop}
                        onClick={item?.onClick}
                      >
                        <div key={index}>
                          <img src={item?.icon} alt="" />
                        </div>
                        <p
                          style={{
                            ...Fonts.b3,
                            color: Colors.neutralShadesOfNero,
                          }}
                        >
                          {item?.title}
                        </p>
                      </li>
                    );
                  })}
                </ul>
                <p className={css.line}></p>
              </div>
            </Col>
            <Col md={12}>
              <LinkButtonWithIcon
                leftIcon={logoutBlackIcon}
                text="Logout"
                primary={false}
                customStyle={{
                  ...Fonts.b3,
                  color: Colors.neutralShadesOfNero,
                }}
              />
            </Col>
          </Row>
        </div>
      </Container>

      <div className={css.BottomTab}>
        <MobileBottomTab state={menuItem} />
      </div>
    </>
  );
};

export default ProfileMobile;
